import { render, staticRenderFns } from "./RegistrationClosed.vue?vue&type=template&id=f196a06e&scoped=true"
import script from "./RegistrationClosed.vue?vue&type=script&lang=js"
export * from "./RegistrationClosed.vue?vue&type=script&lang=js"
import style0 from "./RegistrationClosed.vue?vue&type=style&index=0&id=f196a06e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f196a06e",
  null
  
)

export default component.exports